import React from "react";

interface RedDotCircleProps {
  count: number;
  className?: string;
  placement?: "top-right" | "bottom-right" | "top-left" | "bottom-left";
  showCount?: boolean;
  fontMargin?: boolean;
}

export default function RedDotCircle({
  count,
  className,
  placement,
  showCount,
  fontMargin = true,
}: RedDotCircleProps) {
  return (
    <div
      className={`absolute ${
        placement === "top-right"
          ? "top-[-5px] right-[-5px]"
          : placement === "bottom-right"
          ? "bottom-[-5px] right-[-5px]"
          : placement === "top-left"
          ? "top-[-5px] left-[-5px]"
          : placement === "bottom-left"
          ? "bottom-[-5px] left-[-5px]"
          : "top-[-5px] right-[-5px]"
      } bg-red-500 text-white rounded-full w-[10px] lg:w-[0.8vw] h-[10px] lg:h-[0.8vw] max-w-[10px] lg:max-w-[0.8vw] max-h-[10px] lg:max-h-[0.8vw] flex items-center justify-center ${className}`}
    >
      {showCount ? <span className={`text-[5px] font-sans lg:text-[0.45vw]  leading-none`}>{count}</span> : null}
    </div>
  );
}
